import type { HeaderPortalDOMProps } from './Header.types';

import CartSummaryAccessibilityLogger from '../../../cart/components/atoms/CartSummaryAccessibilityLogger';
import ComponentPortals from '../../../common/components/molecules/ComponentPortals';
import EcommerceSearch from '../../../ecommerce/components/EcommerceLayout/EcommerceSearch';
import HeaderFluidBanner from './HeaderFluidBanner';
import HeaderStickyBanner from './HeaderStickyBanner';

const EcommerceHeader = (props: {
    stayAfterLoginLogoutRedirect?: boolean;
    hideB2BSwitch: boolean;
}) => {
    return (
        <>
            <CartSummaryAccessibilityLogger />
            <ComponentPortals
                cmpName="HeaderFluidBanner"
                render={(domProps: HeaderPortalDOMProps) => (
                    <HeaderFluidBanner
                        featuredNavigation={{
                            items: domProps.featuredNavigation?.items,
                        }}
                        headerTheme={domProps.headerTheme}
                        hideB2BSwitch={props.hideB2BSwitch}
                        stayAfterLoginLogoutRedirect={props.stayAfterLoginLogoutRedirect || false}
                    />
                )}
            />
            <ComponentPortals
                cmpName="HeaderStickyBanner"
                render={(domProps: HeaderPortalDOMProps) => (
                    <HeaderStickyBanner
                        featuredNavigation={{
                            items: domProps.featuredNavigation?.items,
                        }}
                        headerTheme={domProps.headerTheme}
                        stayAfterLoginLogoutRedirect={props.stayAfterLoginLogoutRedirect || false}
                        searchSlot={<EcommerceSearch />}
                    />
                )}
            />
        </>
    );
};

export default EcommerceHeader;
